export enum CampaignPeriodType {
  Permanent,
  Planified,
}
